import { z } from 'zod';

import { PartyFamilyRoleSchema, PartyGenderSchema } from './party-pf-profile.schemas.js';

export const PartyPersonTypeSchema = z.enum(['INDIVIDUAL', 'COMPANY']);
export type PartyPersonType = z.infer<typeof PartyPersonTypeSchema>;

export const PartyStatusSchema = z.enum(['DRAFT', 'ACTIVE', 'ARCHIVED']);
export type PartyStatus = z.infer<typeof PartyStatusSchema>;

export const PartyResponseSchema = z.object({
  id: z.uuid(),
  personType: PartyPersonTypeSchema,
  isForeigner: z.boolean(),
  status: PartyStatusSchema,
  name: z.string(),
  document: z.string().nullable(),
  cnpj: z.string().nullable(),
  legalName: z.string().nullable(),
  tradeName: z.string().nullable(),
  stateRegistration: z.string().nullable(),
  rg: z.string().nullable(),
  nickname: z.string().nullable(),
  occupation: z.string().nullable(),
  jobTitle: z.string().nullable(),
  driversLicenseExpiry: z.iso.date().nullable(),
  photoUrl: z.url().nullable(),
  familyRole: PartyFamilyRoleSchema.nullable(),
  birthDate: z.iso.date().nullable(),
  gender: PartyGenderSchema.nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type PartyResponse = z.infer<typeof PartyResponseSchema>;
